import * as urlUtils from 'utils/url';
import apiUrlConfig from 'configs/apiUrlConfig';
import AuthenticatedRequestService from 'services/requests/Authenticated';

const URLS = {
  INDEX: `${apiUrlConfig.apiEndPoint()}/questions/:id/chart_report`,
};

function insertIdToUrl(url, id) {
  return url.replace(':id', id);
}

class ChartReportApi {
  /**
   * Gets all survey template report.
   * If the parameters from and to are provided then the reports are filtered according to the timestamp.
   *
   * @param {int} surveyId
   * @param {int} from Unix timestamp
   * @param {int} to Unix timestamp
   */
  static getAll(surveyId, filters, category, chart_type, from, to) {
    const INDEX_URL = insertIdToUrl(URLS.INDEX, surveyId);
    let queryParams = filters
      ? { filters, category, chart_type }
      : { category };
    if (from && to) {
      queryParams = { ...queryParams, from, to };
    }
    const FETCH_URL = urlUtils.addQueryParameters(INDEX_URL, queryParams);

    return AuthenticatedRequestService.get(FETCH_URL);
  }
}

export default ChartReportApi;



// WEBPACK FOOTER //
// ./src/apis/reports/ChartReport.js